function accordion(items) {
    const faqItems = document.querySelectorAll(items);
    faqItems.forEach((item) => {
        item.children[0].addEventListener('click', (e) => {
            faqItems.forEach((el) => {
                if (el !== item) {
                    el.children[1].classList.remove('active');
                    for (var icon of el.children[0].children[0].children) {
                        if (icon.classList.contains('faq-container__item__title__icon__plus')) {
                            icon.classList.add('active');
                        } else {
                            icon.classList.remove('active');
                        }

                        if (icon.classList.contains('cs-cookie-container__item__title__icon')) {
                            icon.classList.toggle('active');
                        }
                    }
                }
            });
            for (var icon of item.children[0].children[0].children) {
                icon.classList.toggle('active');
            }
            item.children[1].classList.toggle('active');
        })
    });
}
accordion('.faq-container .faq-container__item');
accordion('.cs-cookie-container .cs-cookie-container__item');

const cookieHidden = () => {
    const cookieBar = document.querySelector('.cookie-bar');
    const btnCookie = document.querySelectorAll('#cookie-yes');
    const btnCookieNo = document.querySelectorAll('#cookie-no');
    const siteFooter = document.querySelector('.site-footer');
    if ( cookieBar ) {
        let cookieUser = localStorage.getItem('certCookieUser');
        if ( cookieUser !== 'yes' ) {
            cookieBar.classList.add('visible');
            siteFooter.classList.add('cookie-views');
        }
        if (btnCookie.length) {
            btnCookie.forEach((btn) => {
                btn.addEventListener('click', (e)=> {
                    localStorage.setItem('certCookieUser', 'yes');
                    cookieBar.classList.remove('visible');
                    siteFooter.classList.remove('cookie-views');
                });
            });
        }
        if (btnCookieNo.length) {
            btnCookieNo.forEach((btn) => {
                btn.addEventListener('click', (e)=> {
                    // window.location.href = "https://www.google.com";
                    localStorage.setItem('certCookieUser', 'yes');
                    cookieBar.classList.remove('visible');
                    siteFooter.classList.remove('cookie-views');
                });
            });
        }
    }
}
cookieHidden();

const navMobile = () => {
    const menuToggle = document.querySelector('.menu-toggle');
    if (!menuToggle) return;
    const modalOverlay = document.querySelector('.js-overlay-modal');
    const navMobile = document.querySelector('.nav-mobile');
    const body = document.querySelector('body');
    menuToggle.addEventListener('click', (e)=> {
        menuToggle.children[0].classList.toggle('active');
        menuToggle.children[1].classList.toggle('active');
        modalOverlay.classList.toggle('active');
        body.classList.toggle('ovfh');
        navMobile.classList.toggle('active');
    });

    const navLinks = document.querySelectorAll('.nav-mobile .primary-ul a');
    if (navLinks.length) {
        navLinks.forEach((link) => {
            link.addEventListener('click', (e)=> {
                menuToggle.children[0].classList.toggle('active');
                menuToggle.children[1].classList.toggle('active');
                modalOverlay.classList.toggle('active');
                body.classList.toggle('ovfh');
                navMobile.classList.toggle('active');
            });
        });
    }
}
navMobile();

var swiper = new Swiper(".testimonials-slider", {
    slidesPerView: 1,
    spaceBetween: 27,
    loop: true,
    // pagination: {
    //     el: ".swiper-pagination",
    //     clickable: true,
    // },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        376: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2,
        },
        1199: {
            slidesPerView: 3,
        },
    },
});

const myModal = new HystModal({
    linkAttributeName: "data-hystmodal",
    catchFocus: false,
    backscroll: false,
    beforeOpen: function(modal) {
        // console.dir(modal);
        document.querySelector('body').classList.add('ovfh');
    },
    afterClose: function(modal) {
        document.querySelector('body').classList.remove('ovfh');
        if (modal.openedWindow.id == 'contactForm') {
            document.querySelector('form#contact').reset();
            document.querySelector('.form-warning').classList.remove('error');
            document.querySelector('.form-warning').classList.remove('success');
            document.querySelector('.form-warning').classList.remove('active');
            document.querySelector('#sendContact').style.pointerEvents = '';

            for (var variable of document.querySelector('form#contact').elements) {
                document.querySelector('.form-warning').innerHTML = '';
                if (variable.required == true) {
                    variable.nextElementSibling.classList.remove('text-danger');
                }
            }

        }
    },
});

function certmodal() {
    var modalButtons = document.querySelectorAll('.js-open-modal'),
    closeButtons     = document.querySelectorAll('.js-modal-close'),
    overlay          = document.querySelector('#overlay-modal'),
    body             = document.querySelector('body');
    modalButtons.forEach(function(item){
        item.addEventListener('click', function(e) {
            e.preventDefault();
            var modalId = this.getAttribute('data-modal'),
            modalElem = document.querySelector('.modal[data-modal="' + modalId + '"]');
            modalElem.classList.add('active');
            overlay.classList.add('active');
            body.style.overflowY = 'hidden';
        });
    });
    closeButtons.forEach(function(item){
        item.addEventListener('click', function(e) {
            var parentModal = this.closest('.modal');
            parentModal.classList.remove('active');
            overlay.classList.remove('active');
            body.style.overflowY = '';
        });
    });
    document.body.addEventListener('keyup', function (e) {
        var key = e.keyCode;
        if (key == 27) {
            document.querySelector('.modal.active').classList.remove('active');
            document.querySelector('.overlay.active').classList.remove('active');
            body.style.overflowY = '';
        };
    }, false);
    overlay.addEventListener('click', function() {
        document.querySelector('.modal.active').classList.remove('active');
        this.classList.remove('active');
        body.style.overflowY = '';
    });
}
// certmodal();

function textareaAutosice() {
    const textarea = document.querySelector('form#contact textarea');
    textarea.addEventListener('input', ()=> {
        textarea.style.height = '';
        textarea.style.height = `${textarea.scrollHeight + 2}px`;
    });
}
textareaAutosice();

function simpleParallaxAction() {
    const images = document.querySelectorAll('.bg-image');
    if (images.length) {
        new simpleParallax(images, {
            delay: 0.1,
            orientation: 'down',
            scale: 2,
            overflow: true
        });
    }
}
simpleParallaxAction();

function validateEmail(email) {
    var re = /^(([^&lt;&gt;()\[\]\\.,;:\s@"]+(\.[^&lt;&gt;()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
